module.exports = __webpack_public_path__ + "media/yahoo-ba646703.svg";